import { gql } from '@apollo/client';

export const fetchAggregatedShipToPartiesForTransactionAccountPPC = gql`
  query fetchAggregatedShipToPartiesForTransactionAccountPPC(
    $id: ID!
    $aggregatedShipToPartyOptions: AggregatedShipToPartyOptions
    $isOrgSearchEnabled: Boolean
  ) {
    transactionAccount(id: $id) {
      id
      aggregatedShipToParty(
        aggregatedShipToPartyOptions: $aggregatedShipToPartyOptions
        isOrgSearchEnabled: $isOrgSearchEnabled
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          key
          totalCount
          data {
            name
            id
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
            priceEligibility
            taxIds {
              id
              label
              metadata {
                vatStatus
              }
              taxExempt
            }
            taxExempt
            taxLabels {
              region
              taxIdLabels {
                description
                displayName
                type
                metadata {
                  type
                  labels {
                    default
                    label
                    vatStatus
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
